/**
 * Timeseries Download API Contract
 *
 * oRPC contract for downloading timeseries data as CSV.
 * The response is a raw CSV string (text/csv).
 */
import { oc } from "@orpc/contract";
import { z } from "zod";
import { TimeseriesDownloadInputSchema } from "@hourly/api/timeseriesDownload";
// ============================================
// Contract
// ============================================
/**
 * GET /timeseries/download
 * Download timeseries data as a CSV file.
 * CompanyId is extracted from JWT token (never from request input).
 * Returns a CSV string with appropriate download headers set by the handler.
 */
export const downloadTimeseries = oc
    .route({
    method: "GET",
    path: "/timeseries/download",
    summary: "Download timeseries data as CSV",
    tags: ["Timeseries"],
})
    .input(TimeseriesDownloadInputSchema)
    .output(z.string());
// ============================================
// Contract Router
// ============================================
export const timeseriesDownloadContract = {
    download: downloadTimeseries,
};
//# sourceMappingURL=timeseriesDownload.js.map